import i18n
	from "../i18n/i18n";

export default class rules {
	constructor() {
		this.language = i18n.language.substr(0, 2)
		this.characters = [];
		const languages = {
			de: require('../data/de/rules.json'),
			en: require('../data/en/rules.json')
		};
		this.rules_json = languages[this.language];

	}

	getCategories(system) {
		if (system === "full") {
			return this.rules_json.systems.full.content;
		} else if (system === "short") {
			return this.rules_json.systems.short.content;
		} else if (system === "music") {
			return this.rules_json.systems.music.content;
		} else if (system === "math") {
			return this.rules_json.systems.math.content;
		}
	}

	getRule(system, category, index) {
		return this.rules_json["systems"][system]["content"][category]["content"][index];
	}
}
